/**
 * Имена тем. Должны совпадать с ключами карты `$themes`
 * в src/styles/themes/themes.config.scss.
 */
export type TThemeName = 'light' | 'dark' | 'prive';

export const DEFAULT_THEME: TThemeName = 'light';

interface IThemeRoute {
    /** Паттерн маршрута Next router (точный путь или префикс). */
    pattern: string;
    theme: TThemeName;
}

/**
 * Реестр маршрутов: какая страница в какой теме.
 *
 * Совпадение по точному пути или по префиксу (`pattern` + `/`).
 * Маршруты, которых здесь нет, используют `DEFAULT_THEME`.
 *
 * Чтобы включить тёмную тему на странице — добавьте сюда одну строку.
 *
 * Примечание: условные темы, зависящие от состояния пользователя
 * (например, Prive по группе), задаются НЕ здесь, а локально через
 * `data-theme` на обёртке (см. ProfileLayoutPage).
 */
export const THEME_ROUTES: readonly IThemeRoute[] = [
    // Пример: {pattern: '/catalog', theme: 'dark'},
];

export const resolveTheme = (pathname: string): TThemeName => {
    const match = THEME_ROUTES.find((route) => pathname === route.pattern || pathname.startsWith(`${route.pattern}/`));

    return match?.theme ?? DEFAULT_THEME;
};
